import {GameView} from "../base/GameView";
import {GameSplashScreen} from "../base/GameSplashScreen";
import {GameWaiter} from "../base/GameWaiter";

export class WaiterLayer extends GameView {
    override onResize() {
        for (let i = this.children.length - 1; i >= 0; i--) {
            let child = this.getChildAt(i);
            if(child instanceof GameWaiter) {
                let gameWaiter = child as GameWaiter;
                gameWaiter.onResize();
            }
        }
    }

}
